export function nextDay(d, dow) {
  d.setDate(d.getDate() + ((dow + (7 - d.getDay())) % 7))
  return d.toLocaleDateString()
}
